import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { ToasterService } from 'angular5-toaster';
import { TramApiService } from "../tram-api.service";
import { StorageService } from "../storage.service";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { passwordMatchValidator } from "../common/passwordMatchValidator";

@Component({
    selector: 'recover-password',
    templateUrl: 'recover-password.component.html',
    styleUrls: ['/../common/account/account.scss', 'recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {
    private activatedRouteParams: ParamMap;

    recoverPasswordForm: FormGroup;
    isAuthenticated: boolean;

    constructor(private activedRoute: ActivatedRoute,
        private router: Router,
        private api: TramApiService,
        private storage: StorageService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) {
        activedRoute.queryParamMap.subscribe(p => {
            if (p.keys.length <= 0)
                return;

            this.activatedRouteParams = p;
        });

        storage.isSensitiveDataExist.subscribe(v => {
            if (this.isAuthenticated === v)
                return;

            this.isAuthenticated = v;

            if (!this.isAuthenticated) {
                if (this.recoverPasswordForm)
                    this.recoverPasswordForm.reset();
            }
        });
    }

    ngOnInit() {
        this.recoverPasswordForm = this.formBuilder.group({
            password: [null, Validators.required],
            confirmation: [null, Validators.required]
        }, { validator: passwordMatchValidator });
    }

    onSubmit() {
        if (!this.recoverPasswordForm.valid)
            return;

        let token: string;
        if (this.activatedRouteParams) {
            if (this.activatedRouteParams.has('token')) {
                token = this.activatedRouteParams.get('token');
                this.api.resetPassword(this.recoverPasswordForm.value.password, token)
                    .then(response => {
                        this.toaster.pop('success', null, 'Пароль успешно изменен');
                        this.router.navigate(['/account']);
                    });
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/recover-password.component.ts